module.exports = __webpack_public_path__ + "img/s-nails.62930ea9.svg";